import { Component, ElementRef, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'sp-edit-quantity-dialog',
    templateUrl: './edit-quantity-dialog.component.html',
    styleUrls: ['./edit-quantity-dialog.component.scss'],
})
export class EditQuantityDialogComponent implements OnInit {
    noOfVariants: number;
    variantsQuantity: number = 1;
    clickedOnButton: boolean = false;
    selectedCount: number;

    private positionRelativeToElement: ElementRef;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { count: number },
        private dialogRef: MatDialogRef<EditQuantityDialogComponent>
    ) {
        this.selectedCount = data.count;
    }

    ngOnInit(): void {}
    updateQuantity(quantity: number): void {
        this.variantsQuantity = quantity;
    }
    updateQuantityToVariants() {
        this.clickedOnButton = true;
        let data = {
            qty: this.variantsQuantity,
            clickedOnButton: this.clickedOnButton,
        };
        this.dialogRef.close(data);
    }
}
